define('common/productSlides',[
],
    function () {

        const SLIDE = ".product-slide";
        const NORMAL = ".product-slide-normal-wrapper";
        const VIDEO = ".product-slide-video-wrapper";

        let videoPlayers = [];

        function init(selector) {
            $(selector).find(".cp-play-video").off("click").on("click", videoPlayButtonClicked);
            $(selector).find(".close-video").off("click").on("click", closeVideoButtonClicked);
            videoPlayers = [];
        }

        function videoPlayButtonClicked(event) {
            // hide the "normal" slide content and display the video instead
            let slide = $(this).closest(SLIDE);
            let normal = $(slide).find(NORMAL);
            let video = $(slide).find(VIDEO);
            $(normal).addClass("d-none");
            $(video).removeClass("d-none");
            play(video);
        }
        function closeVideoButtonClicked(event) {
            // hide the video and display the "normal" slide content instead
            let slide = $(this).closest(SLIDE);
            let normal = $(slide).find(NORMAL);
            let video = $(slide).find(VIDEO);
            $(video).addClass("d-none");
            $(normal).removeClass("d-none");
            pauseAllVideos();
        }

        function play(videoWrapper) {
            let videoFrameId = $(videoWrapper).find(".product-slide-video").attr("id");
            let existingPlayer = videoPlayers.find(p => p.frameId == videoFrameId);
            if (existingPlayer) {
                existingPlayer.ytPlayer.playVideo();
            }
            else if (YT) {
                // this is currently working only for YouTube videos
                let newPlayer = new YT.Player(videoFrameId, {
                    events: {
                        "onReady": playerReady
                    }
                });
            }
        }

        function playerReady(event) {
            videoPlayers.push({ frameId: event.target.getIframe().id, ytPlayer: event.target });
            event.target.playVideo();
        }

        function pauseAllVideos() {
            videoPlayers.forEach(p => p.ytPlayer.pauseVideo());
        }

        return {
            init: init,
            pauseAllVideos: pauseAllVideos
        };
    });

